import React from 'react'

const rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
})

export const formatRupee = (value) => {
    const amount = Number(value)
    return Number.isFinite(amount) ? rupee.format(amount) : ''
}

export const discountPercent = (mrp, finalPrice) => {
    const m = Number(mrp)
    const f = Number(finalPrice)
    if (!m || !f || f >= m) return 0
    return Math.round(((m - f) / m) * 100)
}

// Final price with the struck-through MRP when there is a discount.
const Price = ({ finalPrice, mrp, size, className = '' }) => {
    if (finalPrice == null || finalPrice === '') return null
    const showMrp = discountPercent(mrp, finalPrice) > 0
    return (
        <span className={`mv-price ${size === 'lg' ? 'mv-price-lg' : ''} ${className}`}>
            <span className='mv-price-final'>{formatRupee(finalPrice)}</span>
            {showMrp && (
                <span className='mv-price-mrp'>
                    <span className='mv-visually-hidden'>MRP </span>
                    {formatRupee(mrp)}
                </span>
            )}
        </span>
    )
}

export default Price
